import Corrin from "../../assets/combatants/jrpg/fireemblem/corrin.png";
import CorrinIcon from "../../assets/combatants/jrpg/fireemblem/corrin-icon.png";
import CorrinWin from "../../assets/combatants/jrpg/fireemblem/corrin-win.png";
import CorrinLose from "../../assets/combatants/jrpg/fireemblem/corrin-lose.png";

import Lucina from "../../assets/combatants/jrpg/fireemblem/lucina.png";
import LucinaIcon from "../../assets/combatants/jrpg/fireemblem/lucina-icon.png";
import LucinaWin from "../../assets/combatants/jrpg/fireemblem/lucina-win.png";
import LucinaLose from "../../assets/combatants/jrpg/fireemblem/lucina-lose.png";

import Lyn from "../../assets/combatants/jrpg/fireemblem/lyn.png";
import LynIcon from "../../assets/combatants/jrpg/fireemblem/lyn-icon.png";
import LynWin from "../../assets/combatants/jrpg/fireemblem/lyn-win.png";
import LynLose from "../../assets/combatants/jrpg/fireemblem/lyn-lose.png";

import Lysithea from "../../assets/combatants/jrpg/fireemblem/lysithea-vonordelia.png";
import LysitheaIcon from "../../assets/combatants/jrpg/fireemblem/lysithea-vonordelia-icon.png";
import LysitheaWin from "../../assets/combatants/jrpg/fireemblem/lysithea-vonordelia-win.png";
import LysitheaLose from "../../assets/combatants/jrpg/fireemblem/lysithea-vonordelia-lose.png";

import Edelgard from "../../assets/combatants/jrpg/fireemblem/edelgard-vonhresvelg.png";
import EdelgardIcon from "../../assets/combatants/jrpg/fireemblem/edelgard-vonhresvelg-icon.png";
import EdelgardWin from "../../assets/combatants/jrpg/fireemblem/edelgard-vonhresvelg-win.png";
import EdelgardLose from "../../assets/combatants/jrpg/fireemblem/edelgard-vonhresvelg-lose.png";

export const seriesId = "Fire Emblem";

export default {
  corrin: {
    seriesId,
    id: "corrin",
    name: "Corrin",
    description:
      "Corrin is member of Nohr and Hoshido royalty, she is a kind person who cares deeply for the people she loves.",
    img: Corrin,
    icon: CorrinIcon,
    opWinImg: CorrinWin,
    opLoseImg: CorrinLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human-dragoon",
    bodyShape: "petite",
    eyeColor: "red",
    hairColor: "white",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 2,
    // Pref properties effect 'AI'
    prefAttack: "vagina",
    prefTarget: "vagina",
    uniqueAttackText:
      "Corrin scissors xxxx with animal passion, sending waves of pleasure through her.",
    roughPlayLvl: -15, // how responds to domination either -hates or +likes
    // Prowess is capability
    seductionResistance: 20,
    grapplingProwess: 25,
    tongueProwess: 15,
    touchProwess: 25,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 15,
    // -- resistance is ability to endure pleasure, 1 - 100
    touchResistance: 30,
    breastResistance: 20,
    mouthResistance: 32,
    cockResistance: 15,
    vaginaResistance: 15,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  lucina: {
    seriesId,
    id: "lucina",
    name: "Lucina",
    description:
      "The daughter of Chrom and gifted with the mark of Naga, known as the Brand of the Exalt, on her left eye.",
    img: Lucina,
    icon: LucinaIcon,
    opWinImg: LucinaWin,
    opLoseImg: LucinaLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "human",
    bodyShape: "youthful",
    eyeColor: "blue",
    hairColor: "blue",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "touch",
    prefTarget: "breasts",
    uniqueAttackText:
      "Lucina tenderly fondles xxxx's breasts, teasing her nipples playfully.",
    roughPlayLvl: 10,
    seductionResistance: 25,
    grapplingProwess: 25,
    tongueProwess: 15,
    touchProwess: 25,
    cockProwess: 15,
    vaginaProwess: 15,
    anusProwess: 10,
    touchResistance: 15,
    breastResistance: 25,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 5,
    anusResistance: 10,
    orgasmLimit: 3,
  },
  lyn: {
    seriesId,
    id: "lyn",
    name: "Lyn",
    description:
      "Lyndis, commonly known as Lyn, is named after her maternal grandmother. She is daughter of Hassar, chieftain of the Lorca tribe.",
    img: Lyn,
    icon: LynIcon,
    opWinImg: LynWin,
    opLoseImg: LynLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "shapely",
    eyeColor: "green",
    hairColor: "green",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 1,
    prefAttack: "touch",
    prefTarget: "breasts",
    uniqueAttackText:
      "Lyn rubs her supple tits eagerly against xxxx's cock, smothering it with her soft tit meat.",
    roughPlayLvl: 5,
    seductionResistance: 20,
    grapplingProwess: 25,
    tongueProwess: 25,
    touchProwess: 30,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 15,
    touchResistance: 15,
    breastResistance: 25,
    mouthResistance: 10,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 15,
    orgasmLimit: 3,
  },
  lysithea: {
    seriesId,
    id: "lysithea",
    name: "Lysithea",
    description:
      "Lysithea is the eldest daughter and heir to House Ordelia. She is a magical prodigy whose talents developed at an early age.",
    img: Lysithea,
    icon: LysitheaIcon,
    opWinImg: LysitheaWin,
    opLoseImg: LysitheaLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "tiny",
    eyeColor: "pink",
    hairColor: "white",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 1,
    prefAttack: "tongue",
    prefTarget: "cock",
    uniqueAttackText:
      "Lysithea's cute little tongue, sweety slathers itself over xxxx's hard cock.",
    roughPlayLvl: -10,
    seductionResistance: 35,
    grapplingProwess: 10,
    tongueProwess: 30,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 10,
    anusProwess: 20,
    touchResistance: 25,
    breastResistance: 25,
    mouthResistance: 15,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 20,
    orgasmLimit: 3,
  },
  edelgard: {
    seriesId,
    id: "edelgard",
    name: "Edelgard",
    description:
      "Edelgard is the ninth child of Emperor Ionius IX, the princess and heir to the Adrestian Empire, and a student at the Officers Academy in Garreg Mach Monastery. She is also the house leader of the Black Eagles.",
    img: Edelgard,
    icon: EdelgardIcon,
    opWinImg: EdelgardWin,
    opLoseImg: EdelgardLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "petite",
    eyeColor: "grey",
    hairColor: "white",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "anus",
    uniqueAttackText:
      "Edelgard uses her tongue expertly to dig deep into xxxx's back passage.",
    roughPlayLvl: 15,
    seductionResistance: 25,
    grapplingProwess: 30,
    tongueProwess: 30,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 25,
    touchResistance: 25,
    breastResistance: 25,
    mouthResistance: 10,
    cockResistance: 15,
    vaginaResistance: 15,
    anusResistance: 55,
    orgasmLimit: 3,
  },
};
